import React, { Component } from "react";
import { connect } from 'react-redux';
import * as url from '../../../utils/url';
import axios from '../../../axios';
import * as actionCreators from '../../../modules/actions/index';
import MapReligion from '../../../components/OrganizationSetup/MapReligion/MapReligion';
import EnterpriseBreadcrumb from '../../../components/EnterpriseBreadcrumb/EnterpriseBreadcrumb';

class MapReligionManagement extends Component {
  // constructor(props) {
  //   super(props);
  // }

  componentDidMount() {
    window.scrollTo(0, 0);
    const {organizationId} = this.props.user;
    console.log("did mount management")
    axios.get(url.getExistingMappings(organizationId._id)).then(({data}) => {
      const payload = data.data;
      console.log(payload)
      const {religion} = payload.mapping;
      if(religion.columnName) {
        this.props.onMatchColumn(religion.columnName);
      }
      const religionData = religion.data;
      let allMapping = []
      religionData.forEach((c) => {
        const mapping = c.values.map((v) => {
          return {
            value : v,
            column : {
              label : c.reference.name,
              value : c.reference._id
            }
          }
        })
        allMapping = allMapping.concat(mapping);
      })
      this.props.saveAllReligionMapping(allMapping);
    })
  }

  componentWillUnmount() {
    this.props.resetMapReligionStep();
  }

  handleFileUpload = (columns, data, file) => {
    console.log(columns, data, file)
    this.props.onFileDataProcessed(columns, data, file);
  }

  handleMatchColumn = (matchedColumn) => {
    this.props.onMatchColumn(matchedColumn);
  }

  handleSkipMapping = () => {
    // console.log('Skip performance mapping');
  }

  render() {
    console.log(this.props)
    return (
      <div className="mt60 enterprise-map-page">
      <EnterpriseBreadcrumb 
        linkText="Enterprise Management" 
        link="/home/enterprise-info" 
        activeText="Map Religion"
        {...this.props}
        />
      <MapReligion 
        onProcessedFileUploadData={this.handleFileUpload}
        onSkipReligionMapping={this.handleSkipMapping}
        isRepeatFlow={true}
        {...this.props}/>
      </div>
    );
  }
}

const mapStateToProps = state => {
  console.log(state)
  return {
    user: state.user.profile,
    mapReligion : state.mapping.religion
  }
}

const mapDispatchToProps = dispatch => {
	return {
    resetMapReligionStep: () => dispatch(actionCreators.resetMapReligionStep()),
    nextStep: () => dispatch(actionCreators.mapReligionNextStep()),
    goBack : () => dispatch(actionCreators.mapReligionGoBack()),
    reset : () => dispatch(actionCreators.resetReligion()),
    saveAllReligionMapping : (o,s) => dispatch(actionCreators.saveAllReligionMapping(o,s)),
    onFileDataProcessed: (c,d,f) => dispatch(actionCreators.mapReligionUploadFileSuccess(c,d,f)),
    onMatchColumn: data => dispatch(actionCreators.mapReligionMatchColumnSuccess(data))
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(MapReligionManagement);